import { NavigationGuard } from "vue-router"

// this should be used together with path option that looks like :path([microfrontendPath].*)?
// :path([microfrontendPath].*)? path doesn't add [microfrontendPath] to url so it needs to be added manually
// this change in path is needed to handle url in more elastic way for Inventory micro-frontend
export function beforeEnterMicrofrontend (microfrontendPath: string): NavigationGuard {
  return (to, from, next) => {
    if (!to.path.includes(`inventory/${microfrontendPath}`)) {
      return next({
        path: to.path + (to.path.endsWith('/') ? '' : '/') + microfrontendPath,
        query: to.query,
        hash: to.hash,
      })
    }

    next()
  }
}
